@if (loaderServiceValue.loaderState$ | async) {
  <app-loader></app-loader>
}
<!-- [ngClass]="{'hidden': !isLoading, 'fade-in': isLoading}" -->
<main [ngClass]="{ hidden: !isLoading(), 'fade-in': isLoading() }">
  <app-nav [isScrolled]="isScrolled$()" class="nav" #nav></app-nav>
  <app-home-sliders></app-home-sliders>

  <section class="d-flex flex-column inspire_container gap-3" #content>
    <h2 class="welcome_mssg">INSPIRING A BETTER FUTURE.</h2>
    <div class="d-flex our_why justify-content-between align-items-center">
      <div class="our_why_text">
        <p class="section_tag animated-text" #textContent>OUR WHY.</p>
        <h3
          class="mb-5 rdj_bold our_why_heading_text animated-text"
          #textContent
          >
          <b
            >We believe in the untapped potential within our people
            and communities.</b
            >
          </h3>
          <p class="mb-5 animated-text" #textContent>
            Every great business solution starts with a question. Ours was simple:
            how can we transform communities in Nigeria to make them more
            appealing to businesses and individuals, and, in turn, create
            opportunities that improve the lives of our people?
          </p>
          <a
            class="know-more-btn animated-text"
            (mouseenter)="onMouseColorChange('white')"
            (mouseleave)="onChangeColorBack('#8d0a1f')"
            routerLink="who-we-are/about-us"
            #textContent
            >KNOW MORE <span class="ps-2"> &#8594;</span></a
            >
          </div>
          <div class="our_why_img">
            <div
              class="youtube-vid d-flex justify-content-center align-items-center"
              >
              <iframe
                src="https://www.youtube.com/embed/DoSebnNKzhs?autoplay=1&mute=1&rel=0"
                width="100%"
                height="500px"
                title="A YouTube video"
                [frameBorder]="0"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      <section class="quote_wrapper">
        <blockquote class="quote">
          <h2 id="quote_text" [innerHTML]="typetext()"></h2>
          <p class="mt-5 fs-1 quote-owner">Lucky R. Erherha</p>
          <p class="fs-4">Founder & CEO, Zumera.</p>
        </blockquote>
      </section>

      <!-- <app-projects-slider></app-projects-slider> -->

      <section class="flex-column mb-0 news-section">
        <!-- <app-latest-news
        (mouseenter)="onMouseEnter()"
        (mouseleave)="onMouseLeave()"
      ></app-latest-news> -->

      <div class="my-5 d-flex flex-column">
        <p class="quote_3_p text-center">
          NEXT <span class="rdj_bold">&#8594;</span>
        </p>
        <h3 class="mb-3 text-center rdj_bold">ABOUT US</h3>
        <a
          routerLink="/who-we-are/about-us"
          class="know-more-btn align-self-center"
          >KNOW MORE</a
          >
        </div>

        <app-footer class="w-100 d-none d-sm-block"></app-footer>
        <app-footer-sm class="w-100 d-sm-none"></app-footer-sm>
      </section>
    </main>
